import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ArrowRight, Computer } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface CardProductTypeProps {
  selectedType: string;
  onClick: () => void;
  title: string;
  description: string;
  isActive?: boolean;
  icon?: React.ReactNode;
  isEnabled?: boolean;
  dataCy?: string;
}

export default function CardProductType({
  selectedType,
  onClick,
  title,
  description,
  isActive,
  icon,
  isEnabled = true,
  dataCy,
}: CardProductTypeProps) {
  const { t } = useTranslation(['common', 'onboarding']);
  return (
    <Card
      className={cn(
        'max-w-60 hover:card-blur z-50 relative p-4 h-full min-h-[152px] hover:bg-gray-800 bg-onColor w-full group cursor-pointer border rounded-xl border-gray-700 transition-all',
        isActive && 'bg-gray-800',
        !isEnabled && 'cursor-not-allowed opacity-60'
      )}
      onClick={isEnabled ? onClick : undefined}
      data-cy={dataCy}
    >
      <div
        className='absolute inset-0 z-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300'
        style={{
          background: `
      radial-gradient(ellipse 100% 100% at top left, 
        rgba(64, 73, 147, 0.4) 0%, 
        rgba(64, 73, 147, 0.4) 15%, 
        rgba(64, 73, 147, 0.4) 10%, 
        rgba(64, 73, 147, 0.4) 15%, 
        transparent 60%, 
        #18181b 80%
      )
    `,
        }}
      ></div>

      <div className='relative z-10'>
        <CardHeader className='flex p-0 justify-between'>
          <div className='flex flex-col w-full items-start'>
            <div className='flex items-center justify-between w-full relative'>
              <span>{icon}</span>
              {!isEnabled && (
                <Badge className='!opacity-100' variant='outline'>
                  {t('coming_soon')}
                </Badge>
              )}
              {isEnabled && (
                <ArrowRight className='w-5 h-5 text-gray-400 opacity-0 group-hover:opacity-100 group-hover:text-white transition-all duration-300 absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none' />
              )}
            </div>

            <CardTitle className='mt-6 mb-2 text-base font-semibold leading-6 text-left decoration-slice'>
              {title}
            </CardTitle>
          </div>
        </CardHeader>
        <CardContent className='p-0'>
          <span className=' text-[#A1A1AA] text-sm font-normal leading-5 text-left  decoration-slice'>
            {description}
          </span>
        </CardContent>
      </div>
    </Card>
  );
}
